<template>
  <div>
    <div class="lh_subtitle_container">
      <!--<span v-for="(item, index) in getSubTitle()" :key="index" class="lh_subtitle"
            :class="subTitleActive==index?'li_subtitle_active' : ''"
            :style="getSubTitleClass(item)"
            @click="handleTabClick(index, item)"
            v-if="item!='尾数中' && item!='尾数不中'"
      >{{ item }}</span>-->
      <span v-for="(item, index) in getSubTitle()" :key="index" class="lh_subtitle"
            :class="subTitleActive==index?'li_subtitle_active' : ''"
            :style="getSubTitleClass(item)"
            @click="handleTabClick(index, item)"
      >{{ item }}</span>
    </div>
    <radio-group v-model="playTypeRadio" class="tab-radio-warp" v-if="isRadioDantuo() === 'lianxiao'"
                 @change="onSetRadioRest(true)">
      <radio class="tab-radio" label="1">单注/复式</radio>
      <radio class="tab-radio" label="2">胆拖</radio>
    </radio-group>
    <radio-group v-model="playTypeRadio" class="tab-radio-warp" v-if="isRadioDantuo() === 'lianma'"
                 @change="onSetRadioRest(true)">
      <radio class="tab-radio lianma-radio" label="1">单注/复式</radio>
      <radio class="tab-radio lianma-radio" label="2">胆拖</radio>
      <radio class="tab-radio lianma-radio" label="3" v-if="!isLianmaSan()" :disabled="isLianmaSan()">生肖对碰</radio>
      <radio class="tab-radio lianma-radio" label="4" v-if="!isLianmaSan()" :disabled="isLianmaSan()">尾数对碰</radio>
      <radio class="tab-radio lianma-radio" label="5" v-if="!isLianmaSan()" :disabled="isLianmaSan()">混合对碰</radio>
      <radio class="tab-radio lianma-radio" label="6" v-if="!isLianmaSan()" :disabled="isLianmaSan()">号码对碰</radio>
    </radio-group>
    <g-switch-list4
      :chip="chip"
      class="lmp-vertical"
      :vertical-type="1"
      :horizontalType="24"
      :list="lianmaFilterList()"
      layout="isNumber"
      :current="current"
      :columns="filterColumns()"
      :subtitle="getList().title"
    >
    </g-switch-list4>
    <div class="lmp-block clearBoth" v-if="data.horizontal[0]">
      <g-switch-list4
        :chip="chip"
        class="lmp-vertical"
        :vertical-type="1"
        :title="data.horizontal[0].title"
        :horizontalType="24"
        :layout="isGSWitchListLayout()"
        :current="current"
        :list="data.horizontal[0].list"></g-switch-list4>
    </div>
  </div>
</template>

<script>
import mixin from '../mixins';
import objectPath from 'object-path';
import { Radio, RadioGroup, TabPane, Tabs } from 'element-ui';
import GSwitchList4 from '../../c_game-switch/switch-list/g_switch-4';
import { mapActions, mapState } from "vuex";
import { LH_SUB_TAB_CONFIG } from "../../../utils/lhConfig"; // 横向

export default {
  name: "lh-tab",
  mixins: [mixin],
  components: {
    GSwitchList4,
    Tabs,
    TabPane,
    Radio,
    RadioGroup
  },
  computed: {
    ...mapState({
      playTypeRadio: state => state.home.playTypeRadio,
      lhTabData: state => state.home.lhTabData,
    }),
    playTypeRadio: {
      get() {
        return this.$store.state.home.playTypeRadio
      },
      set(val) {
        this.lianmaRadioValue = val;
        this.$store.state.home.playTypeRadio = val;
      }
    },
  },
  data() {
    return {
      lianmaRadioValue: 1,
      subTitleActive: 0
    };
  },
  methods: {
    ...mapActions({
      onSetPlayTypeRadio: 'home/onSetPlayTypeRadio',
      onSetPlayDantuoTotal: 'home/onSetPlayDantuoTotal',
      onSetLhItemTotal: 'home/onSetLhItemTotal',
      onSetLhTabData: 'home/onSetLhTabData',
    }),
    // 获取子玩法title
    getSubTitleClass(item) {
      /*if (item === '一肖中' || item === '一肖不中') {
        return {
          width: '100%'
        };
      }*/
      let titleLength = this.getSubTitle().length;
      let width = titleLength > 0 ? `${100 / titleLength - 1.8}%` : '';
      return {
        width
      };
    },
    getSubTitle() {
      const sub_category_name = objectPath.get(this.current, 'sub_category_name');
      const TAB_CONFIG = LH_SUB_TAB_CONFIG[sub_category_name];
      return TAB_CONFIG
    },
    getList() {
      const DEFAULT_ITEM = objectPath.get(this.data, 'vertical.0') || {title: '', list: []};
      return DEFAULT_ITEM
    },
    // 连码的玩法比较多，而且要前端处理数据，只涉及连码，其他玩法不涉及
    lianmaFilterList() {
      const list = this.getList().list;
      // 特码的返回，是一个对象
      // if (title === '二全中' || title === '二中特' || title === '特串') {
      //   return list[this.lianmaRadioValue]
      // }
      return list;
    },
    // 判断是否是连码的三全二、三全中,禁用玩法
    isLianmaSan() {
      const title = this.getList().title;
      if (title === "三全中" || title === "三中二" || title === "三中二X") {
        return true;
      }
      return false;
    },
    // 如果是正特、特码，下面玩法的表格展示需要调整
    isGSWitchListLayout() {
      const currentValue = objectPath.get(this.current, 'value');
      if (currentValue === 1 || currentValue === 3) {
        return 'isZhengte';
      }
      return '';
    },
    // tabItem click
    handleTabClick(index, name) {
      // this.$emit("onRestValue");
      this.onSetRadioRest(true);
      this.onSetPlayTypeRadio('1');
      this.onSetLhTabData({
        ...this.lhTabData,
        playedName: name
      });
      this.lianmaRadioValue = 1;
      this.subTitleActive = index;

      const sub_category_id = objectPath.get(this.current, 'sub_category_id');
      this.$store.dispatch("home_PK10/getCurOddsData", {
        sub_category_id,
        lottery_type: this.$route.query.lottery_type || 1,
        category_id: this.$route.query.category_id || 1,
        played_name: name
      });
    },
    // radio 重置 resetSubTitle是否重置子玩法active
    onSetRadioRest(resetSubTitle) {
      if (!resetSubTitle) {
        this.subTitleActive = 0;
      }
      // 切换tab时，清空所选的所有值
      this.$emit("reset");
      // 重置胆拖计算值
      this.onSetPlayDantuoTotal({});
      this.onSetLhItemTotal({});
    },
    // 胆拖
    isRadioDantuo() {
      const currentValue = objectPath.get(this.current, 'value');
      //  6 7 连肖连尾
      if (currentValue === 6 || currentValue === 7) {
        return 'lianxiao';
      }
      // 连码
      if (currentValue === 8) {
        return 'lianma';
      }
      return false;
    },
    // 根据玩法，遍历出对应的columns
    filterColumns() {
      const currentValue = objectPath.get(this.current, 'value');
      const title = this.getList().title;
      // 一肖尾数 合肖
      if (currentValue === 5 || currentValue === 6 || currentValue === 7 || currentValue === 11 ||
        (currentValue === 8 && (this.playTypeRadio == 3 || this.playTypeRadio == 4 || this.playTypeRadio == 5) && (title === '二全中' || title === '二中特' || title === '二中特X' || title === '特串'))
      ) {
        return 2;
      }
      if (currentValue === 15) {
        return 1;
      }
      return 5;
    }
  }
}
</script>

<style scoped lang="stylus">
.el-tabs__item {
  background: red;
}

.lmp-vertical
  /*margin-top 7px*/

.lmp-vertical + .lmp-vertical
  margin-left 7px

.lmp-vertical:nth-of-type(7)
  margin-left 0px

// 一肖尾数，单注、胆拖选项
.tab-radio-warp {
  width: 97.2%;
  border: 1px solid #e6e6e6;
  padding: 10px;

  .tab-radio {
    width: 47%;
    text-align: center
    border-left: 1px solid #e6e6e6;
  }

  .lianma-radio {
    width: 12%;
  }

  .tab-radio:first-child {
    border-left: none;
  }
}

.lh_subtitle_container {
  display: flex;
  justify-content: space-between;
}

// 六合自定义子玩法菜单
.lh_subtitle {
  font-size: 13px;
  padding: 5px;
  text-align: center;
  border: 1px solid #e6e6e6;
  cursor: pointer;
}

.li_subtitle_active {
  background: #0092ff;
  color: #fff;
}
</style>



// WEBPACK FOOTER //
// src/components/pageComponents/lh/tab.vue